<ng-container *transloco="let t">
  <div class="flex items-center justify-between gap-2 border-b border-gray-200 px-3 py-2">
    <div class="flex items-center gap-5">
      <div class="flex items-center gap-2">
        <IToggle
          [checked]="isPromoDaysActivated()"
          (checkedChange)="togglePromoDaysActivation()"
          [disabled]="isToggleDisabled()"
          [loading]="promoDaysLoading()"
          [iTooltip]="toogleTooltipValue()"
        />
        <span class="font-medium tracking-tight text-gray-800">{{ t("strategy-boost.promo_days") }}</span>
      </div>

      @if (isPromoDaysActivated()) {
        <div class="flex items-center gap-2">
          <button
            iButton
            variant="ghost"
            [iTooltip]="t('promo-days-boost.edit_promo_days_date_range')"
            [disabled]="isReadOnly()"
            (click)="editPromoDaysDateRange()"
          >
            @if (!isReadOnly()) {
              <IIcon name="pencil" />
            }
            {{
              t("promo-days-boost.activated_from_start_to_end", {
                start: startDateFmt(),
                end: endDateFmt(),
              })
            }}
          </button>
        </div>
      }
    </div>
    <div>
      <IBadge
        size="sm"
        color="green"
        variant="soft"
        [label]="isPromoDaysActivated() ? 'ON' : 'OFF'"
        [color]="isPromoDaysActivated() ? 'green' : 'gray'"
      />
    </div>
  </div>

  @if (isPromoDaysActivated()) {
    <div class="flex items-center justify-between px-3 py-2">
      <div class="w-[30rem]">
        <input iInput [(ngModel)]="filter" size="sm" [placeholder]="t('strategy-boost.search_by_strategy_name')" />
      </div>
      <div class="flex items-center gap-2">
        <button iButton [iDropdownMenuTrigger]="rowMenu" placement="bottom-end" variant="ghost" size="icon-sm">
          <IIcon name="ellipsis" />
        </button>

        <ng-template #rowMenu>
          <IDropdownMenu>
            <button iDropdownMenuItem (click)="exportAsCsv()"><IIcon name="upload" />{{ t("common.export") }}</button>
            @if (!this.isReadOnly()) {
              <button iDropdownMenuItem (click)="uploadPromoDays()">
                <IIcon name="import" />{{ t("common.import") }}
              </button>
            }
          </IDropdownMenu>
        </ng-template>
      </div>
    </div>

    <div>
      <table iTable class="w-full">
        <thead iTableHead>
          <tr>
            <th iTableTh class="w-1/3 truncate">
              {{ t("sp-strategy-creation.strategy_name") }}
            </th>
            <th iTableTh>{{ t("algo-mode-selection.acos_target") }}</th>
            <th iTableTh>{{ t("page-title.promo_days_boost") }}</th>
            <th iTableTh>{{ t("strategy-boost-table.acos_optimizer") }}</th>
          </tr>
        </thead>
        <tbody iTableBody>
          @for (strategy of paginatedStrategies(); track strategy.strategyId) {
            <tr app-strategy-boost-list-row iTableRow [strategy]="strategy" [dateRange]="dateRange()"></tr>
          }
        </tbody>
      </table>
      <IPaginator
        [length]="filteredStrategies()?.length ?? 0"
        [pageIndex]="pagination().pageIndex"
        [pageSize]="pagination().pageSize"
        (paginationEvent)="pagination.set($event)"
        chatbotSafeArea
      />
    </div>
  }
</ng-container>
